import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { CommissionTier } from '__generated__/api';

export const getCommissionTierFilterInput = (searchCriteria: SearchCriteriaModel): CommissionTier[] | null => {
  if (searchCriteria.commissionTier && searchCriteria.commissionTier.length > 0) {
    return searchCriteria.commissionTier
      .map(type => {
        const result = CommissionTier[CommissionTier[type]];

        return result ? result : null;
      })
      .filter(type => type !== null);
  }

  return null;
};
